import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import Aux from "../../hoc/Auxiliary";
import axiosConfig from "../../axiosConfig";
import * as alertTypes from "../../shared/language.json";
import MaterialUIPickers from "../Datepicker/Datepicker";
import exportPDF from "../../services/exportPDF";
import exportCSV from "../../services/exportCSV";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import Edit from "@material-ui/icons/Edit";
import { Grid } from "@material-ui/core";
import MaterialTable from "material-table";
import { tableIcons } from "../../shared/TableIcons";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../shared/dashboardStyle";

const useStyles = makeStyles(styles);

function ClosedAlerts(props) {

  const classes = useStyles();

  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 14);
  
  const [dateFrom, setDateFrom] = useState(currentDate.toISOString().slice(0, 10));
  const [dateTo, setDateTo] = useState(new Date().toISOString().slice(0, 10));
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [ClosedAlarms, setclosedAlarms] = useState([]);
  let history = useHistory();

 
  const handleDateChangeFinal = (date) => {
    if (date) { 
      setDateTo(date.toISOString().slice(0, 10))
      let previousDate = date.setDate(date.getDate() - 14)  
      setDateFrom((new Date(previousDate)).toISOString().slice(0, 10))
    }
  }

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const datesSubmit = () => {
    setIsLoading(true);
    axiosConfig.get(`/Alarm/AlarmsByStatusIdAndDate?statusId=3&dateFrom=${dateFrom}&dateTo=${dateTo}&search=${search}`)
      .then((res) => {
        setclosedAlarms(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      })
  };

  useEffect(() => {
    axiosConfig.get(`/Alarm/AlarmsByStatusIdAndDate?statusId=3&dateFrom=${dateFrom}&dateTo=${dateTo}&search=${search}`)
      .then((res) => {
        setclosedAlarms(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const columns = [
    {
      field: "id",
      title: "Αρ. Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "beneficiaryId",
      title: "Κωδ. Ωφελούμενου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmSeverity",
      title: "Δείκτης Κινδύνου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmType",
      title: "Τύπος Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "value",
      title: "Τιμή Ειδοποιήσης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "dateCreated",
      title: alertTypes.LABELS.DATEALERT,
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },

    {
      field: "assignmentDate",
      title: "Ημ/νία Ανάληψης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "closureDate",
      title: "Ημ/νία Κλεισίματος",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "assignmentUser",
      title: "Χειριστής Αν.",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "closureUser",
      title: "Χειριστής Κλ.",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
  ];

  let actions = [
    {
      icon: () => <Edit />,
      tooltip: "Επεξεργασία",
      onClick: (e, row) => {
        history.push({
          pathname: "/alert-take-over",
          selected: row.id,
        });
      },
    },
  ];

  return (
    <Aux>
      <Grid item xs={12} style={{ marginTop: "16px" }}>
        <Card>
          <CardHeader color="warning">
            <h1 className={classes.cardTitleWhite}>Ιστορικό Ειδοποιήσεων</h1>
          </CardHeader>
          <CardBody>
            <MaterialUIPickers
              initialDate={dateFrom}
              finalDate={dateTo}
              handleDateChangeFinal={handleDateChangeFinal}
              handleChange={handleSearch}
              datesSubmit={datesSubmit}
              search={false}
            />
            <MaterialTable
              title=""
              icons={tableIcons}
              isLoading={isLoading}
              columns={columns}
              data={ClosedAlarms}
              actions={actions}
              localization={{
                body: {
                  emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
                  filterRow: {
                    filterTooltip: 'Φίλτρο',
                    filterPlaceHolder: 'Αναζήτηση'
                  }
                },
                toolbar: {
                  addRemoveColumns: "Προσθέστε η αφαιρέστε κολώνες",
                  showColumnsTitle: "Δείξτε κολώνες",
                  addTooltip: "Προσθήκη",
                  searchTooltip: "Αναζήτηση",
                  searchPlaceholder: "Αναζήτηση",
                  exportTitle: "Εξαγωγή",
                  exportAriaLabel: "Εξαγωγή",
                  exportCSVName: "Εξαγωγή σε CSV",
                  exportPDFName: "Εξαγωγή σε PDF",
                },
                pagination: {
                  firstTooltip: "Πρώτη Σελίδα",
                  lastTooltip: "Τελευταία Σελίδα",
                  previousTooltip: "Προηγούμενη Σελίδα",
                  nextTooltip: "Επόμενη Σελίδα",
                  labelDisplayedRows: "{from}-{to} από {count}",
                  labelRowsSelect: "Εγγραφές ανά Σελίδα",
                },
                grouping: {
                  placeholder: "Σύρετε για να ομαδοποιήσετε",
                  groupedBy: "Σύρετε για να ομαδοποιήσετε",
                },
                header: {
                  actions: "Ενέργειες",
                },
              }}
              options={{
                searchFieldAlignment: "left",
                pageSize: 10,
                pageSizeOptions: [10, 15, 20],
                columnsButton: true,
                exportButton: true,
                exportPdf: (columns, data) => {
                  exportPDF(columns, data);
                }, exportCsv: (columns, data) => {
                  exportCSV(columns, data);
                },
                search: false,
                grouping: true,
                sorting: true,
                filtering: true,
                exportAllData: true,
              }}
            />
          </CardBody>
        </Card>
      </Grid>
    </Aux>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapState: (mapPayload, editMapPoint, setter) => {
      dispatch(actions.editMapStateAsync(mapPayload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClosedAlerts);
